const showDeliverySlotDrawer = () => {
  if (typeof document !== 'undefined') {
    (document as any).querySelector('[data-id="change-slot-btn"]').click();
  }
};

export default showDeliverySlotDrawer;
